<div class="modal-header bg-secondary">
    <b class="card-title"><i class="fas fa-server mr-2"></i>Seleziona server</b>
    <div class="float-right" *ngIf="timer>0">
        <i class="mr-3">(tra <b>{{timer}} sec</b> avvio automatico)</i>
        <button type="button" class="btn btn-sm btn-danger" (click)="stopTimer()">STOP</button>
    </div>
</div>
<div class="modal-body pb-0">
    <ul class="list-group">
        <li class="list-group-item p-0" *ngFor="let c of configs">
            <div class="row border-bottom p-2">
                <div class="col-lg-4 mb-2">
                    <button  type="button" class="btn btn-block btn-outline-primary text-lg h-100" (click)="select(c)">{{c['name']}}</button>
                </div>
                <div class="col-lg-8">
                    <!-- <b>{{c['name']}}</b><small class="ml-2 text-danger" *ngIf="selected['name']==c['name']">(automatico)</small><br/> -->
                    <ng-container *ngIf="isArray(c['serverUrl'])">
                        <ng-container  *ngFor="let s of c['serverUrl'];let i=index">
                            <input type="radio" #serverUrl name="serverUrl" [(ngModel)]="c['selectedServerUrl']" (click)="stopTimer();enable=true" value="{{s}}" class="mr-2"/>
                            <span>{{s}}<div class="float-right badge badge-warning" *ngIf="serverUrl.checked">automatico al prossimo avvio</div></span><br>
                        </ng-container>
                    </ng-container>
                    <small *ngIf="!isArray(c['serverUrl'])">{{c['serverUrl']}}</small>
                </div>
               
            </div>
        </li>
    </ul>
</div>